import { defineMessage } from 'services/localization';

export const messages = {
    allowToEditThisField: defineMessage('allow_to_edit_this_field'),
    anyField: defineMessage('any_fieldname'),
    canChangeFieldTo: defineMessage('can_change_fieldname_to'),
    cannotChangeFieldTo: defineMessage('cannot_change_fieldname_to'),
};
